// Module-level cache of image src URLs that have been fully loaded this session.
// Persists across React component remounts (navigation) but clears on page reload.
export const imageLoadCache = new Set()
